import React from 'react';
import cn from 'classnames';

import STRIPE_LOGO from 'assets/images/logos/stripe-logo-blue.png';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './ListHeader.module.scss';

const ListHeader = ({ title }) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      data-bem="ListHeader"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.title}>{title}</div>

      <div className={CN.desktopHeader}>
        <div
          className={cn({
            [CN.cell]: true,
            [CN.infoColumn]: true,
          })}
        >
          {t('stylistScreen.staffMember')}
        </div>
        <div
          className={cn({
            [CN.cell]: true,
            [CN.stylistColumn]: true,
          })}
        >
          {t('stylistScreen.bookableColumn')}
        </div>
        <div
          className={cn({
            [CN.cell]: true,
            [CN.pinColumn]: true,
          })}
        >
          {t('stylistScreen.pincodeAccess')}
        </div>
        <div
          className={cn({
            [CN.cell]: true,
            [CN.emailColumn]: true,
          })}
        >
          {t('stylistScreen.remoteAccess')}
        </div>
        <div
          className={cn({
            [CN.cell]: true,
            [CN.stripeColumn]: true,
          })}
        >
          <img src={STRIPE_LOGO} alt="" className={CN.stripeColumnImg} />
          {t('stylistScreen.paymentsAccount')}
        </div>
        <div className={CN.actionColumn}></div>
      </div>
    </div>
  );
};

export default ListHeader;
